import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', {
        username: username.trim(),
        password,
        role: 'viewer',
        client: 'web',
      });
      localStorage.clear();
      localStorage.setItem('token', data.token);
      localStorage.setItem('userType', 'user');
      localStorage.setItem('role', 'viewer');
      localStorage.setItem('username', data.user.username);
      localStorage.setItem('expiryDate', data.user.expiry_date);
      navigate('/viewer');
    } catch (err) {
      setError(err.response?.data?.message || 'Đăng nhập thất bại, vui lòng thử lại');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.title}>FPV STREAMING</div>
        <div style={styles.subtitle}>Đăng nhập Máy Xem để xem camera trực tiếp</div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Tên đăng nhập:</label>
          <input
            style={styles.input}
            placeholder="Nhập tài khoản"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoCapitalize="none"
            required
          />
          <label style={styles.label}>Mật khẩu:</label>
          <input
            style={styles.input}
            placeholder="Nhập mật khẩu"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Đang xác thực...' : 'ĐĂNG NHẬP MÁY XEM'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0f172a',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: '16px',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: 380,
    backgroundColor: '#1e293b',
    borderRadius: 16,
    padding: '24px 20px',
    color: '#f8fafc',
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
    border: '1px solid #334155',
    boxSizing: 'border-box',
  },
  title: { fontSize: 22, fontWeight: 800, marginBottom: 4, textAlign: 'center', color: '#f8fafc', letterSpacing: '0.5px' },
  subtitle: { fontSize: 13, color: '#94a3b8', textAlign: 'center', marginBottom: 20 },
  label: { fontSize: 12, color: '#94a3b8', marginBottom: 4, display: 'block' },
  input: {
    width: '100%',
    height: 46,
    padding: '0 14px',
    borderRadius: 10,
    border: '1px solid #334155',
    backgroundColor: '#0f172a',
    color: '#f8fafc',
    marginBottom: 14,
    fontSize: 15,
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    height: 48,
    borderRadius: 10,
    border: 'none',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    marginTop: 8,
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
  },
  error: {
    color: '#f87171',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    padding: '10px',
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 14,
    textAlign: 'center',
    border: '1px solid rgba(239, 68, 68, 0.2)',
  },
};